export default {
taskRecord: {
  title: "Ganjaran Tugas",
  loading: "Memuatkan...",
  empty: "Tiada ganjaran",
  completed: "Tugas telah selesai",
  desc: "Selesaikan tugas untuk mendapatkan ganjaran",
  close: "Tutup",
  add: "Tambah",
  addEmail: "Tambah Emel",
  addPhoneNumber: "Tambah Nombor Telefon",
  addBirthday: "Tambah Tarikh Lahir",
  downloadNow: "Muat Turun Sekarang",
  phone: "Nombor telefon",
  email: "Alamat emel",
  bank: "Kad bank",
  birthday: "Tarikh lahir",
  download: "Muat turun",
  downloadApp: "Muat turun APP",
  registerBonus: "Bonus Pendaftaran",
  firstInviteBonus: "Bonus Jemputan Pertama",
  invite: "Jemput",
  inviteNow: "Jemput Rakan",
  go: "Pergi",
  receive: "Tuntut",
  received: "Telah dituntut",
  task: "Tugas",
  claimRewards: 'Tuntut Ganjaran',
  receiveSuccess: 'Ganjaran berjaya dituntut',
  receiveFail: 'Gagal menuntut ganjaran'
}
};
